module.exports = __webpack_public_path__ + "static/media/A1-5-Dextrion-cod87.7f4c0c7b.png";